import React, { useState, useEffect } from 'react';
import './GraphNode.css';

/**
 * GraphNode Component
 * Represents a single node in the graph (DOM-based, extensible UI)
 */
function GraphNode({ node, position, isActive, isProcessing, onClick }) {
  const { id, label, type, status, metadata } = node;
  const [isAnimating, setIsAnimating] = useState(false);
  
  // Auto-timeout animation after 3 seconds
  useEffect(() => {
    if (isActive || isProcessing) {
      setIsAnimating(true);
      const timer = setTimeout(() => {
        setIsAnimating(false);
      }, 3000); // 3 seconds timeout
      
      return () => clearTimeout(timer);
    } else {
      setIsAnimating(false);
    }
  }, [isActive, isProcessing]);
  
  // Determine node color based on type
  const getNodeColor = () => {
    switch (type) {
      case 'user':
        return '#4A90E2';
      case 'user-agent':
        return '#50C878';
      case 'flight-mcp':
        return '#FF6B6B';
      case 'hotel-mcp':
        return '#FFA500';
      case 'merchant-agent':
        return '#9B59B6';
      case 'payment-processor':
        return '#E74C3C';
      case 'backend':
        return '#34495E';
      default:
        return '#95A5A6';
    }
  };
  
  // Determine status indicator
  const getStatusIndicator = () => {
    if (status === 'active') {
      return <div className="node-status-indicator active" />;
    } else if (status === 'completed') {
      return <div className="node-status-indicator completed" />;
    } else if (status === 'error') {
      return <div className="node-status-indicator error" />;
    }
    return null;
  };
  
  const nodeColor = getNodeColor();
  const isHighlighted = isAnimating || status === 'active';
  
  return (
    <div
      className={`graph-node ${isAnimating && isActive ? 'active' : ''} ${isAnimating && isProcessing ? 'processing' : ''} ${status || ''}`}
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        borderColor: isHighlighted ? '#4A90E2' : nodeColor
      }}
      onClick={() => onClick && onClick(node)}
    >
      {getStatusIndicator()}
      <div className="node-header" style={{ backgroundColor: getNodeColor() }}>
        <span className="node-type">{type || 'node'}</span>
      </div>
      <div className="node-body">
        <div className="node-label">{label || id}</div>
        {metadata && metadata.messageCount && (
          <div className="node-meta">
            {metadata.messageCount} message{metadata.messageCount !== 1 ? 's' : ''}
          </div>
        )}
        {metadata && metadata.lastMessage && (
          <div className="node-last-message" title={metadata.lastMessage}>
            {metadata.lastMessage.length > 30 
              ? metadata.lastMessage.substring(0, 30) + '...' 
              : metadata.lastMessage}
          </div>
        )}
      </div>
    </div>
  );
}

export default GraphNode;

